import { DaymapIcon, DaymapIconType } from "daymap-react"
import { Link } from "react-router-dom"

import styles from './styles.module.scss';

type NavItemProps = {
    to: string;
    selected?: boolean;
    title: string;
    iconType: DaymapIconType;
    minimized?: boolean;
    onClick?: () => void;
}

export const NavItem:React.FC<NavItemProps> = ({to, iconType, title, selected, minimized, onClick }) => {
    const classNames:string[] = [styles.menu];
    selected && classNames.push(styles.selected);
    minimized && classNames.push(styles.minimized);

    const itemContent = <>
        <DaymapIcon iconType={iconType} fontSize="small" />
        {!minimized && <div className={styles.title}>{title}</div>}
    </>

    if (onClick)
        return <div onClick={onClick} className={`${styles.clickdiv} ${classNames.join(' ')}`}>
            {itemContent}
        </div>

    return <Link to={to} className={classNames.join(' ')}>
        {itemContent}
    </Link>
}